import {Component} from 'react'

import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import actions from '../../../../redux/actions/ui/dataImport/strategies/productCreateStrategy.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default class ProductCreateStrategy extends Component {
  render() {
    return (
      <BaseStrategy
        {...this.props}
        actions={actions}
        EditForm={EditForm}
        ReconcileForm={ReconcileForm}
      />
    )
  }
}

ProductCreateStrategy.title = actions.title
const option = {
  value: 'create_products',
  display: 'Create Products',
  category: 'products',
  Component: ProductCreateStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
ProductCreateStrategy.option = option
